export function parseDatasetJson(raw, context) {
  try {
    return JSON.parse(raw || '{}');
  } catch (error) {
    // Thrown before app.mount(), this would leave the whole page blank.
    if (window.Sentry) {
      window.Sentry.captureException(error, { extra: { context } });
    }

    return {};
  }
}
